export default __webpack_public_path__ + "static/media/2454.f9584df1.png";